var render = function render(){var _vm=this,_c=_vm._self._c;return _c('commonSelect',{attrs:{"value":_vm.value,"placeholder":_vm.placeholder,"clearable":_vm.clearable,"idKey":"UnitId","labelKey":"UnitName","get-data-func":_vm.getDataFunc,"params":_vm.params},on:{"input":v=>_vm.$emit('input',v),"unitData":v=>_vm.$emit('change', v)}})
}
var staticRenderFns = []

export { render, staticRenderFns }